var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xC3\x83\xE2\x80\x98\xC3\x83\xC2\xAB\xC3\x83\xC2\xAE\xC3\x83\xC2\xA9_1",
    clipPath: "url(#clip0_638_533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M49.9989 99.9978C77.6125 99.9978 99.9978 77.6125 99.9978 49.9989C99.9978 22.3853 77.6125 0 49.9989 0C22.3853 0 0 22.3853 0 49.9989C0 77.6125 22.3853 99.9978 49.9989 99.9978Z",
    fill: "url(#paint0_linear_638_533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M82.9381 40.9008C82.788 36.9501 82.9 32.8806 81.5241 29.1114C79.9465 24.3339 76.007 20.4347 71.2519 18.828C67.3169 17.3781 63.0659 17.4229 58.9359 17.3243C52.816 17.3154 46.6961 17.3266 40.5807 17.3535C38.6222 17.4297 36.6614 17.4072 34.7096 17.6246C30.7589 17.9495 26.7409 19.1417 23.6575 21.7187C20.872 23.9753 18.9157 27.1596 18.0463 30.6263C17.1701 33.9742 17.2597 37.4655 17.067 40.8941C17.067 46.6285 17.0379 52.3652 17.0692 58.0997C17.2866 62.0728 17.1611 66.1803 18.6513 69.9428C20.3051 74.577 24.2043 78.3058 28.8519 79.87C32.1505 81.0375 35.6888 81.2683 39.16 81.2661C42.2188 81.3871 45.2799 81.3154 48.3387 81.3288C53.858 81.1787 59.3931 81.47 64.9057 81.0509C69.4435 80.7327 74.109 79.2761 77.3807 75.9865C80.9012 72.7394 82.4474 67.9126 82.7096 63.2381C83.1219 55.8028 82.8642 48.3495 82.9426 40.903L82.9381 40.9008ZM76.7197 63.5338C76.5269 65.1876 76.2491 66.8526 75.5813 68.3899C74.4183 71.2537 71.8972 73.5058 68.9572 74.4291C66.1135 75.4285 63.0681 75.3658 60.0967 75.5383C54.8351 75.5294 49.5734 75.7086 44.3118 75.5607C40.9594 75.6347 37.5891 75.5831 34.2547 75.2112C30.8351 74.8504 27.4244 73.2773 25.4524 70.3708C23.2676 67.2089 23.2317 63.2246 23.0614 59.5361C23.0524 54.9423 22.9964 50.3507 23.0412 45.7591C23.1107 42.8862 22.9673 40.0089 23.1891 37.1406C23.2944 33.405 24.0205 29.2907 26.9561 26.689C30.1068 23.6257 34.7499 23.3546 38.8911 23.2089C45.9477 23.0588 53.0065 23.0722 60.0676 23.1126C64.1348 23.3277 68.5897 23.247 72.0317 25.7658C74.5774 27.5832 76.0989 30.5232 76.5269 33.582C77.0222 37.1383 76.9348 40.7484 76.946 44.3316C77.0468 47.7714 77.0244 51.2156 76.937 54.6554C76.9751 57.6156 76.9169 60.5803 76.7197 63.5338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M66.0527 28.4168C64.1704 29.0756 62.9849 31.2493 63.5093 33.1877C64.0135 35.3927 66.5345 36.8224 68.6925 36.1681C70.8303 35.6616 72.3967 33.2213 71.6482 31.0812C71.0073 28.8202 68.2242 27.4196 66.0527 28.4168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M59.6687 35.7804C56.1169 33.3222 51.5993 32.3989 47.3461 33.0622C42.6446 33.7883 38.2637 36.5401 35.7001 40.567C33.2575 44.3115 32.4643 49.0869 33.6049 53.4118C34.6402 57.4611 37.3292 61.0331 40.8833 63.2202C44.4329 65.4275 48.8138 66.2947 52.9304 65.5373C57.7752 64.7395 62.2122 61.7233 64.6883 57.4768C66.806 53.9003 67.485 49.4858 66.4788 45.4477C65.522 41.5261 63.0256 38.0213 59.6687 35.7827V35.7804ZM58.8374 55.6236C56.9707 58.0773 54.0329 59.6886 50.9561 59.9238C45.8738 60.502 40.6166 57.0241 39.3909 52.0157C38.5393 48.8605 39.2945 45.3222 41.3606 42.79C43.0503 40.6701 45.5511 39.2493 48.2178 38.8012C53.3001 37.8846 58.8262 40.986 60.4262 45.9474C61.569 49.1698 60.9169 52.9233 58.8418 55.628L58.8374 55.6236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_638_533",
    x1: 6.63978,
    y1: 88.912,
    x2: 94.1804,
    y2: 10.3507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C65A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EF5531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#DC1E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A71095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5134D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.8384f9e104f56f82715af4ae70e014df.svg";
export { ForwardRef as ReactComponent };